import { geoOrthographic, geoPath, geoGraticule } from "d3-geo";
import { select } from "d3-selection";
import { feature } from "topojson-client";
import { renderPins, renderArcs, updatePins, updateArcs } from "./pins";

export const BASE_LON = 30;
export const BASE_LAT = -10;
const CX = 550;
const CY = 350;
const R = 290;

export function initGlobe(svgEl, data) {
    const projection = geoOrthographic()
        .scale(R)
        .translate([CX, CY])
        .rotate([BASE_LON, BASE_LAT, 0])
        .clipAngle(90);
    const path = geoPath(projection);

    const svg = select(svgEl);

    svg.append("circle")
        .attr("class", "world-map__glow")
        .attr("cx", CX)
        .attr("cy", CY)
        .attr("r", R + 6);

    const sphereData = { type: "Sphere" };
    const gratData = geoGraticule().step([15, 15])();
    const equatorData = {
        type: "LineString",
        coordinates: range(-180, 181, 5).map((l) => [l, 0]),
    };

    const pSphereFill = svg
        .append("path")
        .datum(sphereData)
        .attr("class", "world-map__ocean");
    const pGrat = svg
        .append("path")
        .datum(gratData)
        .attr("class", "world-map__grid");
    const pEquator = svg
        .append("path")
        .datum(equatorData)
        .attr("class", "world-map__equator");

    const gLand = svg.append("g").attr("class", "world-map__land");
    const gSphereOutline = svg
        .append("path")
        .datum(sphereData)
        .attr("class", "world-map__sphere-outline");
    const gArcs = svg.append("g").attr("class", "world-map__arcs");
    const gPins = svg.append("g").attr("class", "world-map__pins");

    let landPaths;
    let pins;
    let arcs;

    const ready = fetch(data.topojson_url)
        .then((r) => r.json())
        .then((world) => {
            const countries = feature(world, world.objects.countries);
            landPaths = gLand
                .selectAll("path")
                .data(countries.features)
                .enter()
                .append("path")
                .attr("class", "world-map__country");

            arcs = renderArcs(gArcs, data.arcs || [], data.locations);
            pins = renderPins(gPins, data.locations, projection);
            redraw();
        });

    function redraw() {
        pSphereFill.attr("d", path);
        pGrat.attr("d", path);
        pEquator.attr("d", path);
        if (landPaths) landPaths.attr("d", path);
        gSphereOutline.attr("d", path);
        if (arcs) updateArcs(arcs, path);
        if (pins) updatePins(pins, projection);
    }

    return { projection, redraw, ready };
}

function range(start, stop, step) {
    const out = [];
    for (let v = start; v <= stop; v += step) out.push(v);
    return out;
}
